// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { boolean, string, number, maybeString, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

const isCalculatedAttributeDeveloper = anyOf(
  objectOf({
    id: string,
    name: string,
    email: string,
  }),
  nullOrUndefined
);

export const isGetApiCalculatedAttributesAppGroupIdResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: anyOf(maybeString, nullOrUndefined),
      creation_type: string,
      type: string,
      data_type: string,
      is_draft: boolean,
      marked_as_deleted: boolean,
      status: anyOf(maybeString, nullOrUndefined),
      status_reason: anyOf(maybeString, nullOrUndefined),
      last_processed: anyOf(maybeString, nullOrUndefined),
      last_edited: string,
      last_edited_by: isCalculatedAttributeDeveloper,
      created_at: string,
      created_by: isCalculatedAttributeDeveloper,
      recurring_refresh_enabled: boolean,
      tag_names: arrayOf(string),
      segments_count: number,
    })
  ),
  hits: number,
  max_count: number,
  active_count: number,
});
